import * as _ from "lodash";
import { IOfferCategory } from "../../../models/Category";

export function formatCategoryLabel(category: IOfferCategory) {
  return `${category.translations["en-US"]} / ${
    category.translations["fr-CA"]
  }`;
}

export function hasChildCategories(
  categoryValue: IOfferCategory | string,
  categories?: IOfferCategory[]
): boolean {
  if (typeof categoryValue === "string") {
    return !!(
      categories &&
      getChildCategoriesFromCategoryId(categories, categoryValue) &&
      getChildCategoriesFromCategoryId(categories, categoryValue).length > 0
    );
  } else {
    return !!(
      categoryValue &&
      categoryValue.sub_categories &&
      categoryValue.sub_categories.length > 0
    );
  }
}

export function getCategoryNameFromValue(
  categories: IOfferCategory[],
  categoryId: string,
  onlyEnglish?: boolean
) {
  const sub_categories = _.flatten(
    categories.map(cat => cat.sub_categories || [])
  );
  const flatCategories = [...categories, ...sub_categories];
  const categoryFound = _.find(flatCategories, category =>
    category ? category.id === categoryId : false
  );

  // If the category is found, return the label
    if (categoryFound) {
      return onlyEnglish ? categoryFound.label : categoryFound.label;
    }

    // If no category is found, return null
    return null;
}

export function getChildCategoriesFromCategoryId(
  categories: IOfferCategory[],
  categoryId: string
) {
  const found = _.find(categories, category => category.id === categoryId);
  return found && found.sub_categories ? found.sub_categories : [];
}
